<template>
  <button type="button" v-html="label" @click="click" />
</template>

<script>
export default {
  name: "ButtonBasic",
  props: {
    label: {
      type: String,
      required: true
    },
    to: String
  },
  methods: {
    click() {
      if (this.to) this.$router.push(this.to);
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  max-width: $button-max-width;
  overflow: visible;
  background: transparent;
  color: $color-primary-1;
  font: inherit;
  vertical-align: middle;
  outline: none;
  line-height: normal;
  cursor: pointer;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  &:hover {
    text-decoration: underline;
  }
}
</style>
